"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeNamePipe = exports.SizeIdPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL LIBRARY BITS
const size_service_1 = require("./size.service");
let SizeIdPipe = class SizeIdPipe {
    constructor(_size) {
        this._size = _size;
    }
    transform(value) {
        return this._size.getSizeById(value);
    }
};
exports.SizeIdPipe = SizeIdPipe;
exports.SizeIdPipe = SizeIdPipe = __decorate([
    (0, core_1.Pipe)({ name: 'sizeId' }),
    __metadata("design:paramtypes", [size_service_1.SizeService])
], SizeIdPipe);
let SizeNamePipe = class SizeNamePipe {
    constructor(_size) {
        this._size = _size;
    }
    transform(value) {
        return this._size.getSizeByName(value);
    }
};
exports.SizeNamePipe = SizeNamePipe;
exports.SizeNamePipe = SizeNamePipe = __decorate([
    (0, core_1.Pipe)({ name: 'sizeName' }),
    __metadata("design:paramtypes", [size_service_1.SizeService])
], SizeNamePipe);
//# sourceMappingURL=size.pipe.js.map